import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import { Play, Pause } from "lucide-react";

export default function Waveform({ url, testid }) {
  const containerRef = useRef(null);
  const wsRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    const ws = WaveSurfer.create({
      container: containerRef.current,
      waveColor: "#3f3f46",
      progressColor: "#E6B34A",
      cursorColor: "#E6B34A",
      height: 44,
      barWidth: 2,
      barGap: 1,
      barRadius: 3,
      url,
    });
    wsRef.current = ws;
    ws.on("ready", () => setReady(true));
    ws.on("play", () => setPlaying(true));
    ws.on("pause", () => setPlaying(false));
    ws.on("finish", () => setPlaying(false));
    return () => { try { ws.destroy(); } catch (e) {} };
  }, [url]);

  return (
    <div className="flex items-center gap-3 mt-3" data-testid={testid}>
      <button
        onClick={() => wsRef.current?.playPause()}
        aria-label={playing ? "Pause preview" : "Play preview"}
        className="shrink-0 w-9 h-9 rounded-full bg-[#E6B34A] text-[#0A1030] flex items-center justify-center hover:bg-[#CF9A34] transition-colors disabled:opacity-50"
        disabled={!ready}
      >
        {playing ? <Pause className="w-4 h-4" fill="currentColor" /> : <Play className="w-4 h-4 ml-0.5" fill="currentColor" />}
      </button>
      <div ref={containerRef} className="flex-1 min-w-0" />
    </div>
  );
}
